import React, { useState } from 'react';

const PropertyForm = ({ onAddProperty }) => {
  const [formData, setFormData] = useState({
    title: '',
    location: '',
    price: '',
    bedrooms: '',
    bathrooms: '',
    area: '',
    description: '',
    features: '',
    images: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validacija
    if (!formData.title || !formData.location || !formData.price) {
      alert('Naslov, lokacija i cijena su obavezni!');
      return;
    }
    
    // Formatiranje podataka
    const newProperty = {
      title: formData.title,
      location: formData.location,
      price: parseInt(formData.price),
      bedrooms: parseInt(formData.bedrooms || 0),
      bathrooms: parseInt(formData.bathrooms || 0),
      area: parseInt(formData.area || 0),
      description: formData.description,
      features: formData.features.split(',').map(f => f.trim()).filter(f => f),
      images: formData.images.split(',').map(img => img.trim()).filter(img => img),
    };

    onAddProperty(newProperty);
    
    // Resetiranje forme
    setFormData({
      title: '',
      location: '',
      price: '',
      bedrooms: '',
      bathrooms: '',
      area: '',
      description: '',
      features: '',
      images: ''
    });
  };

  return (
    <form onSubmit={handleSubmit} style={styles.form}>
      <h3 style={styles.title}>Dodaj novu nekretninu</h3>
      
      <div style={styles.formGroup}>
        <label style={styles.label}>Naslov</label>
        <input
          type="text"
          name="title"
          value={formData.title}
          onChange={handleChange}
          required
          style={styles.input}
        />
      </div>
      
      <div style={styles.formGroup}>
        <label style={styles.label}>Lokacija</label>
        <input
          type="text"
          name="location"
          value={formData.location}
          onChange={handleChange}
          required
          style={styles.input}
        />
      </div>
      
      <div style={styles.grid}>
        <div style={styles.formGroup}>
          <label style={styles.label}>Cijena (€)</label>
          <input
            type="number"
            name="price"
            value={formData.price}
            onChange={handleChange}
            required
            style={styles.input}
          />
        </div>
        
        <div style={styles.formGroup}>
          <label style={styles.label}>Broj soba</label>
          <input
            type="number"
            name="bedrooms"
            value={formData.bedrooms}
            onChange={handleChange}
            required
            style={styles.input}
          />
        </div>
        
        <div style={styles.formGroup}>
          <label style={styles.label}>Broj kupatila</label>
          <input
            type="number"
            name="bathrooms"
            value={formData.bathrooms}
            onChange={handleChange}
            required
            style={styles.input}
          />
        </div>
        
        <div style={styles.formGroup}>
          <label style={styles.label}>Površina (m²)</label>
          <input
            type="number"
            name="area"
            value={formData.area}
            onChange={handleChange}
            required
            style={styles.input}
          />
        </div>
      </div>
      
      <div style={styles.formGroup}>
        <label style={styles.label}>Opis</label>
        <textarea
          name="description"
          value={formData.description}
          onChange={handleChange}
          required
          style={styles.textarea}
          rows="4"
        ></textarea>
      </div>
      
      <div style={styles.formGroup}>
        <label style={styles.label}>Karakteristike (odvojene zarezom)</label>
        <input
          type="text"
          name="features"
          value={formData.features}
          onChange={handleChange}
          placeholder="Parking, Lift, Klima, Terasa"
          style={styles.input}
        />
      </div>
      
      <div style={styles.formGroup}>
        <label style={styles.label}>Slike URL (odvojene zarezom)</label>
        <textarea
          name="images"
          value={formData.images}
          onChange={handleChange}
          required
          style={styles.textarea}
          rows="3"
          placeholder="https://example.com/slika1.jpg, https://example.com/slika2.jpg"
        ></textarea>
      </div>
      
      <button type="submit" style={styles.button}>Dodaj nekretninu</button>
    </form>
  );
};

const styles = {
  form: {
    backgroundColor: 'white',
    padding: '1.5rem',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
  },
  title: {
    marginBottom: '1.5rem',
    paddingBottom: '0.5rem',
    borderBottom: '1px solid #eee'
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '1rem',
    marginBottom: '1rem'
  },
  formGroup: {
    marginBottom: '1.5rem'
  },
  label: {
    display: 'block',
    marginBottom: '0.5rem',
    fontWeight: '600'
  },
  input: {
    width: '100%',
    padding: '10px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    fontSize: '1rem'
  },
  textarea: {
    width: '100%',
    padding: '10px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    fontSize: '1rem',
    resize: 'vertical'
  },
  button: {
    padding: '12px 24px',
    backgroundColor: '#27ae60',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '1rem',
    fontWeight: '600'
  }
};

export default PropertyForm;